<template>
  <div>
       <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
      <span v-if="snackbar_msg!=null">{{ snackbar_msg }}</span>
      <v-btn dark text @click="snackbar = false">Close</v-btn>
    </v-snackbar>

    <v-col cols="12" v-if="commn_grp_list!=null">
      <v-combobox
        dense
        required
        v-model="commn_grp"
        :items="commn_grp_list"
        item-text="grp_name"
        label="Group"
        hint="Select Group"
         persistent-hint
        outlined
      />
    </v-col>
    <v-tabs background-color="deep-purple accent-4" centered dark icons-and-text>

      <v-tab @click="comm_type('notice-album')">
        Notice/Album
        <v-icon>mdi-image-album</v-icon>
      </v-tab>

      <v-tab @click="comm_type('calendar')">
        Calendar
        <v-icon>mdi-calendar</v-icon>
      </v-tab>
    </v-tabs>
    <v-card>
        <v-card-text v-if="tab=='notice-album'">
           Notice album
        </v-card-text>
        <v-card-text v-else-if="tab=='calendar'">
           calendar
        </v-card-text>
    </v-card>
  </div>
</template>
<script>
import axios from "axios";
export default {
  data: () => ({
    snackbar_msg: "",
    snackbar: false,
    color: "",
    //
    tab:'group-notice',
    commn_grp_list:null,
    commn_grp:null,
  }),
  methods: {
    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },
    comm_type(type){
        this.tab = type;
    },
  },
  mounted() {
    axios
      .post("/communicationGroup/getAllGroups")
      .then(res => {
          this.commn_grp_list = res.data.commn_grp_list
      })
      .catch(error => {})
      .finally(() => {});
  }
};
</script>